import axios from "axios";

const submitOrder = async (orderDetails: Record<string, any>) => {
  //   console.log("test", orderDetails.cartDetail);
  // Configure the Axios request
  const config = {
    method: "post",
    url: `/api/service/order/process`,
    headers: {
      "Content-Type": "application/json",
    },
    data: orderDetails,
    maxRedirects: 5,
  };

  // Make the request
  return await axios(config)
    .then((response) => {
      console.log(`Order placed successfully`, response);
      return response.data;
    })
    .catch((error) => {
      console.error(`Error placing  the order`, error); // Handle errors
      return {
        error: true,
      };
    });
};

export { submitOrder };
